import Complaints from '@/views/Complaints/Index'
import ComplaintsComplaints from '@/views/Complaints/Complaints/Index'
import ComplaintsComplaintsComplaint from '@/views/Complaints/Complaints/Complaint'
import ComplaintsStorageComplaintsList from '@/views/Complaints/StorageComplaintsList/Index'
import ComplaintsQualitativeNotesList from '@/views/Complaints/QualitativeNotes/Index'
import CodeCompliancesList from '@/views/Complaints/CodeCompliancesList/Index'
import StopCards from '@/views/Complaints/StopCards/Index'
import InternalComplaint from '@/views/Complaints/InternalComplaints/InternalComplaint/Index'

export default [
    {
        path: '/complaints',
        name: 'complaints',
        component: Complaints,
        meta: {
            title: 'Jakość',
            menuRendered: true,
            menuTitle: 'Jakość',
            permission: 'complaints',
            icon: 'mdi-message-alert',
        },
        redirect: { name: 'complaintsComplaints' },
        children: [
            {
                path: '/complaints/complaints',
                name: 'complaintsComplaints',
                component: ComplaintsComplaints,
                meta: {
                    title: 'Reklamacje / Lista Reklamacji',
                    menuRendered: true,
                    menuTitle: 'Lista reklamacji',
                    requiresAuth: true,
                    permission: 'complaints',
                },
            },
            {
                path: '/complaints/complaints/create',
                name: 'complaintsComplaintsCreate',
                component: ComplaintsComplaintsComplaint,
                meta: {
                    title: 'Reklamacje / Nowa reklamacja',
                    requiresAuth: true,
                    permission:  'complaints_create'
                },
            },
            {
                path: '/complaints/complaints/edit/:id',
                name: 'complaintsComplaintsEdit',
                component: ComplaintsComplaintsComplaint,
                meta: {
                    title: 'Reklamacje / Edycja reklamacji',
                    requiresAuth: true,
                    permission:  'complaints'
                },
            },
            {
                path: '/storage-complaints',
                name: 'complaintsStorageComplaintsList',
                component: ComplaintsStorageComplaintsList,
                meta: {
                    title: 'Zwroty',
                    menuRendered: true,
                    menuTitle: 'Zwroty',
                    requiresAuth: true,
                    permission: 'complaints_warehouse',
                },
            },
            {
                path: '/qualitative-note',
                name: 'complaintsQualitativeNotesList',
                component: ComplaintsQualitativeNotesList,
                meta: {
                    title: 'Uwagi jakościowe',
                    menuRendered: true,
                    menuTitle: 'Uwagi jakościowe',
                    requiresAuth: true,
                    permission: 'qualitative_notes',
                },
            },
            {
                path: '/compliances',
                name: 'codeCompliancesList',
                component: CodeCompliancesList,
                meta: {
                    title: 'Kontrola kodów EAN',
                    menuRendered: true,
                    menuTitle: 'Kontrola kodów EAN',
                    requiresAuth: true,
                    permission: 'ean_codes_compliance',
                },
            },
            {
                path: '/stop-cards/stop-cards',
                name: 'stopCards',
                component: StopCards,
                meta: {
                    title: 'Karty stop',
                    menuRendered: true,
                    menuTitle: 'Karty stop',
                    requiresAuth: true,
                    permission: 'stop_card',
                },
            },
            {
                path: '/complaints/internal-complaints/create',
                name: 'complaintsInternalComplaintCreate',
                component: InternalComplaint,
                meta: {
                    title: 'Reklamacje / Nowa Reklamacja Wewnętrzna',
                    requiresAuth: true,
                    permission: ['internal_complaints_basic_create', 'internal_complaints_create'],
                },
            },
            {
                path: '/complaints/internal-complaints/:id',
                name: 'complaintsInternalComplaintEdit',
                component: InternalComplaint,
                meta: {
                    title: 'Reklamacje / Edycja Reklamacji Wewnętrznej',
                    requiresAuth: true,
                    permission: ['internal_complaints_basic_update', 'internal_complaints_update', 'complaints_confirm_update'],
                },
            },
        ],
    },
]